<template>
  <div class="main-map-comp">

    <GmapMap class="mainmap"
      ref="gmap"
      :center="this.centerMap"
      :zoom="12"
      map-type-id="terrain"
      style=""
      :options="mapOptions"
    >
        <gmapcluster :styles="clusterStyle">
            <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                :icon="{url : '/images/marker/marker_40.png'}"
                @click="showInfoWindow(m)"
            />
        </gmapcluster>
    </GmapMap>

    <transition name="fade">
        <Autocomplete v-if="this.showAddressField" @closeAutocomplete="showAddressMap()" @centerMap="centerMapAutocomplete"></Autocomplete>
    </transition>
    <transition name="fade">
        <div class="confirm-btn" v-if="this.confirmbutton">
            <button type="button" @click="selectConfirm()" class="btn-md button-theme btn-block">Conferma Selezione</button>
        </div>
    </transition>
    <SideBar
        :host="this.host"
        :zonestatus="this.showZone"
        :opened="this.sideOpened"
        :sidelock="this.sidelock"
        :modestatus="this.isdark"
        @locksidebar="switchLockSideBar()"
        @openSideBar="openSideBar()"
        @darkmode="switchDarkMode()"
        @erasemap="SideBarEvents_eraseSearchShape(true)"
        @closemap="close()"
        @showzone="showZoneMap()"
        @showpins="showPinsMap()"
        @showaddress="showAddressMap()"
        @drawpolygon="drawPolygon()"
    ></SideBar>
    <LeftSideBar :opened="leftOpened" @showimmobile="previewImmobile($event)" :results="currentResults"></LeftSideBar>
    <PreviewImmobile :immobile="previewImmobileObj" @close="closePreview()"></PreviewImmobile>

  </div>
</template>

<script>

import SideBar from './SideBarMapComponent';
import PreviewImmobile from './PreviewImmobileComponent';
import LeftSideBar from './SideSearchListComponent';
import GoogleMapDrawer from './MapFunction/GoogleMapDrawer';
import GoogleMapDrawerButtons from './MapFunction/GoogleMapDrawerButtons';
import GoogleMapEvents from './MapFunction/GoogleMapEvents';
import SideBarEvents from './MapFunction/SideBarEvents';
import Autocomplete from './AutoCompleteComponent';
import gmapcluster from 'vue2-google-maps/src/components/cluster';
import { loadGmapApi } from 'vue2-google-maps';
const mapstyle_dark = require("./Styles/json/mapstyle_dark.json");
const mapstyle_light = require("./Styles/json/mapstyle_light.json");

export default {
  mixins: [
      GoogleMapDrawer,
      GoogleMapEvents,
      GoogleMapDrawerButtons,
      SideBarEvents],
  props: ['currentsearch', 'host', 'colors'],
  components: {
      SideBar,
      Autocomplete,
      gmapcluster,
      LeftSideBar,
      PreviewImmobile
  },
  methods: {
    /**
     * Mostro o nascondo le zone
     */
    showZoneMap(event) {

        // Chiudo la sidebar
        this.closeSideBar();

        // Switcho lo stato di showZone per mostrare le zone
        this.showZone = !this.showZone;

        this.getZone(this.map, this.colors);

    },

    drawPolygon() {},

    /**
     * Setto il dark mode
     */
    switchDarkMode(event) {
        // Switcho la dark mode
        this.isdark = !this.isdark;

        // Chiudo la sidebar
        this.closeSideBar();

        if(this.isdark) {
            this.map.setOptions({ styles: mapstyle_dark });
        } else {
            this.map.setOptions({ styles: mapstyle_light });
        }
    },

    /**
     * Preview Immobile
     */
    previewImmobile(event) {

        this.previewImmobileObj = event;
    },

    /**
     * Chiudo la preview
     */
    closePreview(event) {
        this.previewImmobileObj = null;
    },

    /**
     * Switcho la variabile di lock della sidebar
     */
    switchLockSideBar(event) {

        // Switcho
        this.sidelock = !this.sidelock;

        // Chiudo la sidebar
        this.closeSideBar();
    },

    /**
     * Mostro o nascondo i pins
     */
    showPinsMap(event) {

        // Chiudo la sidebar
        this.closeSideBar();

        // Switcho lo stato di showPins per mostrare i pin
        this.showPins = !this.showPins;

        // Disegno i pins
        this.SideBarEvents_drawPins(this.dataResult);
    },


    /**
     * Close SideBar
     */
    closeSideBar() {
        if(!this.sidelock) {
            this.sideOpened = false;
        }
    },

    showAddressMap(event) {
        // Chiudo la sidebar
        this.closeSideBar();

        // Switcho lo stato di showAddress per mostrare il campo Autocomplete
        this.showAddressField = !this.showAddressField;
    },

    /**
     * Mostro la infowindow sul marker passato
     */
    showInfoWindow(marker) {

        if(this.currentInfoWindow) {
            this.currentInfoWindow.close();
        }

        let template = '<div style="width: 310px">'+
            '<hr>' +
            '<img src="" width="310px"/>' +
            '<hr>' +
            '<p>' + marker.customInfo.description + '</p>'+
            '<p style="font-size: 1.3em"><b>Prezzo ' + marker.customInfo.price + '</b></p>'+
            '</div>';

        this.currentInfoWindow = new google.maps.InfoWindow({
            content: template
        });

        // Non so quanto è grande il marker trovata soluzione qui: https://stackoverflow.com/a/24715250

        this.currentInfoWindow.setOptions({position:marker.getPosition(),
                       pixelOffset:new google.maps.Size(0,-40),
                       map:this.map});

        // Apro la InfoWindow
        this.currentInfoWindow.open(this.map, marker);

    },


    /**
     * Apre e chiude la sidebar
     */
    openSideBar(event) {
        this.sideOpened = !this.sideOpened;
    },

    /**
     * Metodo di selezione di una singola zona
     */
    selectZone(mapObject, zone) {
        this.selectZoneProp = true;
        
        zone.getProperty('selected') ? zone.setProperty('selected', false) : zone.setProperty('selected', true);
        
        mapObject.data.forEach( item => {
            if(!item.getProperty('selected') && ( item.getProperty('type') !== 'comune')) {
                mapObject.data.overrideStyle(item, {
                        fillOpacity: 0.3,
                });
            }
        });

        this.createGeoJson(mapObject, true);


    },

    deselectComuni(mapObject, zonaCliccata) {
        mapObject.data.forEach( item => {
            if(item.getProperty('selected') && ( item.getProperty('type') === 'comune') && item.getProperty('id') !== zonaCliccata.getProperty('id')) {
                item.setProperty('selected', false);
            }
        });
    },


    /**
     * Centro la mappa in base all'autocomplete
     */
    centerMapAutocomplete(event) {

        // Setto il centro della mappa
        this.centerMap = event;

        // Svuolo il datalayer
        this.emptyDataLayer();

        // Aggiunto il punto sulla mappa
        this.currentAddress = this.map.data.add(
            new google.maps.Data.Feature({
                properties: {
                    radius: 200
                },
                geometry: new google.maps.Data.Point(event)

            })
        );

        this.createGeoJson(this.map, false);
    },


    /**
     * Chiudo la mappa
     */
    close() {
      $(".main-map-comp").fadeOut();
      $("html, body").css({
        overflow: "auto",
        height: "auto"
      });
    },


    /**
     * Svuoto datalayer
     */
    emptyDataLayer(type = null){
        const self = this;

        this.map.data.forEach(function(feature) {
            self.map.data.remove(feature);
        });

        this.closeLeftBar();
    },


    /**
     * Recupera i geojson dalle zone
     */
    getZone(mapObject, colors) {

        // Setto il colore delle zone
        this.GoogleMapDrawer_setColor(mapObject, colors);

        // Creo l'evento on click su datalayer per evidenziare le zone
        this.GoogleMapEvents_setClickEvent(mapObject);

        // Creo l'evento hover sulle zone
        this.GoogleMapEvents_setHoverEvent(mapObject);

        // Creo l'evento mouseout sulle zone
        this.GoogleMapEvents_setOutsideEvent(mapObject);

        // Disegno le zone
        this.SideBarEvents_drawZone(mapObject);
    },


    /**
     * Metodo che converte datalayer nel GeoJson
     */
    createGeoJson(map, fromzone = false) {
        let self = this;

        if(fromzone) {
            map.data.toGeoJson(function(obj) {
                obj.features = obj.features.filter(function(value, index, arr){
                    return value.properties.selected;
                });
                self.dataResult = obj;
                if(self.dataResult.features.length > 0){
                    self.confirmbutton = true;
                }
                else{
                    self.confirmbutton = false;
                }
                $('#geojson_desktop').val(JSON.stringify(self.dataResult));
                $('#geojsonmobile').val(JSON.stringify(self.dataResult));
            });
        } else {
            map.data.toGeoJson(function(obj) {
                self.dataResult = obj;
                self.confirmbutton = true;
                $('#geojson_desktop').val(JSON.stringify(self.dataResult));
                $('#geojsonmobile').val(JSON.stringify(self.dataResult));
            });
        }

    },

    reset() {

    },

    loadLeftBarResults(search) {
        // Mostro il loading dall'istanza principale
        this.$root.isLoading('loading-toast');

        const params = {
            geojson: search,
            is_map: true
        }

        // Effettuo la chiamata al server
        window.axios.post(process.env.MIX_BASE_URL + 'immobili/search', params).then( res => {
            this.leftOpened = true;
            this.currentResults = res.data.data;
            this.$root.stopLoading();

        }).catch( error => {
            // Stoppo il loading
            this.$root.stopLoading();

            // Mostro alert
            this.$root.alertHttp('loading-toast', 'Problemi nel caricamento dati');
        })
    },

    closeLeftBar() {
        this.leftOpened = false;
        this.currentResults = [];
    },


    /**
     * Conferma selezione
     */
    selectConfirm() {
        this.closeLeftBar();

        this.$root.mapselected = true;
        this.close();
    }
  },

  mounted() {
      
    this.closebutton = true;
    this.confirmbutton = false;
    if(this.host.capoluogo_center){
        this.centerMap = {
            lat: this.host.capoluogo_center.coordinates[1],
            lng: this.host.capoluogo_center.coordinates[0],
        };
    }

    // Stanzio il drawer
    this.GoogleMapDrawer_startDrawing({ stylemap: mapstyle_light});

  },

  beforeMount() {
            // Controllo di non aver già caricato la mappa
            if(! this.$root.mapLoaded){
                // Carico lo script di gmaps
                loadGmapApi({
                    key: this.$root.host ? this.$root.host.google_maps_key : null,
                    libraries: 'places,drawing',
                });
                // Imposto la mappa come caricata
                this.$root.mapLoaded = true;
            }
        },

  data() {
    return {
      mapOptions: {
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        rotateControl: false
      },
      shapeStyle: {
        fillColor: this.colors.secondary,
        fillOpacity: 0.4,
        strokeColor: this.colors.secondary,
        strokeWeight: 3,
        editable: true
      },
      selectZoneProp: false,
      centerMap: {lat:44.699125, lng:10.639077},
      closebutton: false,
      confirmbutton: false,
      points: null,
      currentCircle: [],
      currentPolygon: [],
      currentAddress: null,
      currentResults: [],
      zone: null,
      infowindow: null,
      previewImmobileObj: null,
      poly: null,
      showZone: false,
      showPins: false,
      showAddressField: false,
      map: null,
      drawingManager: null,
      sideOpened: false,
      leftOpened: false,
      dataResult: null,
      markers: [],
      firstload: true,
      currentInfoWindow: null,
      sidelock: false,
      isdark: false,
      zoneEvent: {
          click: null,
          hover: null
      },
      clusterStyle: [{
            textColor: 'black',
            textSize: 12,
            url: '/images/cluster/cluster_75.png',
            height: 70,
            width: 70
        },
        {
            textColor: 'black',
            textSize: 13,
            url: '/images/cluster/cluster_85.png',
            height: 80,
            width: 80
        }
       ]
    };
  }
};
</script>

<style lang="scss">
    @import './Styles/main.css';
</style>
